import { GET_CONFIG } from '../../graqhql/queries'

export default ({ store } = {}) => ({
  path: '/sign-in',
  name: 'sign-in',
  component: () => import(/* webpackChunkName: "sign-in" */ '../../views/SignIn.vue'),
  async beforeEnter (to, from, next) {
    await store.query({ query: GET_CONFIG })
    next()
  },
})
